import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class GlobalsService {
    core: any = {
        actions:  [
            {
                id: 1,
                name: 'GET'
            },
            {
                id: 2,
                name: 'POST'
            },
            {
                id: 3,
                name: 'PUT'
            },
            {
                id: 4,
                name: 'DELETE'
            }
        ],
        modules: [
            {
                id: 'role',
                name: 'Role',
            },
            {
                id: 'user',
                name: 'User',
            },
            {
                id: 'permission',
                name: 'Permission',
            },
            {
                id: 'route',
                name: 'Route',
            }
        ],
        role: {
            superAdmin: 1,
            admin: 2,
            user: 3
        }
    };
    brandsafety: any = {
        siteName: 'brandsafety'
    };
    ca: any = {
        booking: {
            bookingType: [
                {id: 1, name: 'CPD', status: 1},
                {id: 2, name: 'CPD Livestream', status: 1},
                {id: 3, name: 'CPD Book Theo Giờ', status: 1},
                {id: 4, name: 'CPM', status: 1},
                {id: 5, name: 'SOV', status: 1}
            ],
            type: {
                cpd: 1,
                cpdLivestream: 2,
                cpdForHour: 3,
                cpm: 4,
                sov: 5,
            },
            status: {
                waitApprove: 1,
                booked: 2,
                bookWithContract: 3,
                running: 4,
                finished: 5,
                cancel: 6,
                bookCpmWait: 7,
                bookCpmMissing: 8,
                pending: 9,
                bookCpdWait: 10
            }
        }
    };
    user: any = {
        guideDoc: '',
        avatar: {
            default: './assets/styles/default/images/user-default.png',
            system: './assets/styles/default/images/system.png'
        }
    };
    createUserUrl: any = 'https://analytics.admicro.vn/register';
    fontDefault: any = `"Inter",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans","Liberation Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"`
}
